import { OptionalLink, OptionalLinkProps } from '../01-core/OptionalLink';
import { Media, MediaProps } from './Media';
import { sanitize } from '../../utils/sanitize';

export interface LogoProps extends OptionalLinkProps {
  /** The logo */
  logo?: MediaProps;
  /** Inline svg logo */
  inline_logo?: string;
  /** Link on the logo */
  href?: string;
  /** Compact logo */
  compact?: boolean;
  /** Individual logo */
  individual?: boolean;
  /** Additional class */
  className?: string;
}

/** A logo (inline or as image) */
export const Logo = ({
  logo,
  href,
  inline_logo,
  compact,
  individual,
  className,
  ...props
}: LogoProps) => {
  return (
    <OptionalLink
      span={true}
      className={[
        'logo',
        compact && 'logo--compact',
        individual && 'logo--individual',
        className,
      ].join(' ')}
      href={href}
      {...props}
    >
      {inline_logo && (
        <div
          className="logo__image logo__image--inline"
          dangerouslySetInnerHTML={{ __html: sanitize(inline_logo) }}
        />
      )}
      {logo && <Media className="logo__image" contain={true} {...logo} />}
    </OptionalLink>
  );
};
